export * from './StrapImageWrapper';
